<template>
  <v-data-table
    :items="items"
    :loading="loading"
    :headers="headers"
    class="elevation-1"
  >
    <template v-slot:item.action="{ item }" v-if="isDetailed">
      <ShippingMiscForm
        :instance="item"
        :is-edit="true"
        :ticketid="id"
      />
      <ShippingLineItemDelete :instance="item" />
    </template>
  </v-data-table>
</template>

<script>
import ShippingMiscForm from "./ShippingMiscForm";
import ShippingLineItemDelete from "./ShippingLineItemDelete";
export default {
  name: "ShippingMiscTable",
  components: { ShippingLineItemDelete, ShippingMiscForm },
  props: {
    // Array of random shipping items
    items: {
      type: Array,
      required: true,
      default: () => {}
    },
    // The id of the ticket. Propped through URL
    id: {
      type: [Number, String],
      required: true
    },
    isDetailed: {
      type: Boolean,
      required: true,
      default: false
    },
    loading: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  data() {
    return {
      headers: [
        { text: "Item", sortable: true, value: "item" },
        { text: "Quantity", sortable: true, value: "quantity" },
        { text: "Notes", sortable: true, value: "notes" },
        { text: "Actions", sortable: false, align: "right", value: "action" }
      ]
    };
  }
};
</script>
